import { render, staticRenderFns } from "./AppNavigationDrawer.vue?vue&type=template&id=a5d54258&"
import script from "./AppNavigationDrawer.js?vue&type=script&lang=js&"
export * from "./AppNavigationDrawer.js?vue&type=script&lang=js&"
import style0 from "./AppNavigationDrawer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VImg,VNavigationDrawer})
